import { ReactElement } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import classNames from 'classnames';

// Components
import { FormikInputField, FormikInputFieldProps } from '../PureFormElements';

// Styles
import styles from '../Facets/Facets.module.scss';

export const FormikInputFieldWithSearch = (props: FormikInputFieldProps): ReactElement => {
  const { formikKey, placeholder, title, disabled } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormikInputField
        formikKey={formikKey}
        noOffset
        placeholder={placeholder}
        startIcon={<SearchIcon />}
        title={title}
      />
      <Box sx={{ ml: -5 }}>
        <IconButton
          aria-label="search"
          className={classNames(styles['search-icon'])}
          disabled={disabled}
          size="medium"
          type="submit"
        >
          <ArrowForwardIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
